import React, { useEffect, useState } from "react";
import { FaPlus, FaSearch, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";

import { connect } from "react-redux";
import PActions from "../../Stores/redux/Persisted/Actions";
import UnpActions from "../../Stores/redux/Unpersisted/Actions";

import MainLayout from "../Common/MainLayout";
import DataTable from "../../Components/Table/DataTable";
import NewOfficeForm from "./NewOfficeForm";
import api from "../../Services/Api/api";
import { useNavigate } from "react-router-dom";

const OfficesScreen = ({ offices, user, setScreenState }) => {
  const [filteredOffices, setFilteredOffices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!offices?.length) load();
  }, []);

  // Filter & Search Logic
  useEffect(() => {
    let filtered = offices;

    if (searchTerm) {
      filtered = filtered.filter((office) =>
        office.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredOffices(filtered);
  }, [searchTerm, offices]);

  const load = async () => {
    setLoading(true);
    try {
      const { offices, officeCategories } = await api.get(
        "v1/district-admin/office",
        {
          filter: JSON.stringify({
            where: { district: user.district._id },
            populate: "subdivision block deptBlock circle lac type",
            sortby: "createdAt",
            order: -1,
          }),
        }
      );

      setScreenState({
        offices: offices.map((x) => ({
          ...x,
          officeName: x.office?.name,
          subdivisionName: x.subdivision?.name,
          blockName: x.block?.name,
          deptBlockName: x.deptBlock?.name,
          circleName: x.circle?.name,
          lacName: x.lac?.name,
          typeName: x.type?.name,
          categoryName: officeCategories.find((y) => y._id === x.type?.category)
            ?.name,
          coordString: `${x.coord?.lat || ""}-${x.coord?.lng || ""}`,
        })),
      });
    } catch (e) {
      console.error(e);
      toast.error(e.message);
    }
    setTimeout(() => {
      setLoading(false);
    }, 0);
  };

  const columns = [
    { label: "Name", accessor: "name" },
    { label: "Type", accessor: "typeName" },
    { label: "Category", accessor: "categoryName" },
    { label: "Sub Division", accessor: "subdivisionName" },
    { label: "Block", accessor: "blockName" },
    { label: "Dept Block", accessor: "deptBlockName" },
    { label: "Circle", accessor: "circleName" },
    { label: "LAC", accessor: "lacName" },
    { label: "Location", accessor: "coordString" },
    { label: "Details", accessor: "details" },
  ];

  return (
    <MainLayout screenName="offices">
      <main className="offices-screen">
        {/* Page Title & Actions */}
        <div className="page-header">
          <h1>
            Departments & Offices{" "}
            {loading ? <FaSpinner className="spinner" /> : null}
          </h1>
          <button className="add-btn" onClick={() => setShowModal(true)}>
            <FaPlus /> Add New Office
          </button>
        </div>

        <div className="filters">
          <div className="search-bar">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Table */}
        <DataTable
          columns={columns}
          data={filteredOffices}
          searchable={false}
          emptyList={loading ? "Loading Data" : null}
          onRowClick={(item) => navigate(`/office/${item._id}`)}
        />

        {/* Modal for New Office */}
        <NewOfficeForm
          key={(!!showModal).toString()}
          {...{
            isOpen: showModal,
            onClose: () => setShowModal(false),
            onSuccess: () => load(),
          }}
        />
      </main>
    </MainLayout>
  );
};

const SCREEN_NAME = "OFFICES_SCREEN";

const mapStateToProps = (state) => ({
  offices: state.vState[SCREEN_NAME]?.offices || [],
  user: state.pState.AUTH.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfficesScreen);
